import { createAuthClient } from 'better-auth/react'
import { customSessionClient, magicLinkClient } from 'better-auth/client/plugins'
import { organizationClient, adminClient } from 'better-auth/client/plugins'

// Create the Better Auth client
const authClient = createAuthClient({
    baseURL: process.env.REACT_APP_NODE_SERVER_URL,
    sessionName: 'session',
    plugins: [
        magicLinkClient(),
        organizationClient(),
        customSessionClient(),
        adminClient(),
    ],
})

// Export the client instance for direct API calls
export { authClient }
